/**
 * 常量类
 */
// 定义常量类
export const Constants = {
    HOME: 'home', //首页 0
    EMAIL_QUERY: 'emailQuery', //新申请邮件填写 0
    SELECT_PAGE: 'selectPage', //选择一人还是2人申请 0
    PERSONAL_INFO: 'personalInfo',//申请人基本资料填写 1
    EMAIL_VERIFY: 'emailVerify',//邮箱验证 新申请、继续申请->2 新申请->0 
    LIVE_EMPLOYMENT: 'liveEmployment', //住屋生活资料 3
    LIVE_EMPLOYMENT2: 'liveEmployment2',//第二人住屋生活资料 3
    DECLARATION: 'declaration', //声明资格 4  
    INFORMATION_PREVIEW: 'informationPreview',  //住屋个人生活预览 4
    FILE_INDEX: 'fileIndex',  //证明档案上传 5
    FILE_INDEX2: 'fileIndex2', //第二人证明档案上传 5
    TERMS: 'terms', //声明、条款细则 6
    APPLY_SUCCESS: 'applySuccess', //申请成功 7 
    QUERY_CONDICTION: 'queryCondiction', //查询状态 输入条件 0 
    QUERY_RESULT: 'queryResult',//查询状态 查询结果 1 
  };



// WEBPACK FOOTER //
// ./src/assets/js/constants.js